export const SET_CONNECTION = "setConnection"
export const SET_NO_ACCOUNT= "setNoAccount"
export const DETERMINE_LOGIN = "determineLogin"
export const SET_LINK_SENT = "setLinkSent"
export const VERIFY_AUTHENTICATION = "verifyAuthentication"
export const TRIGGER_REGISTRATION = "triggerRegistration"
export const START_MOBILE = "startMobile"
